import { render, staticRenderFns } from "./LabelView.vue?vue&type=template&id=e8b74b86&scoped=true&"
import script from "./LabelView.vue?vue&type=script&lang=js&"
export * from "./LabelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b74b86",
  null
  
)

export default component.exports